<template>
  <div class="card">
    <div class="card-body">
      <EnrollmentMenu
        :id="`${id}-menu`"
        :item="item"
        :eventBus="eventBus"
        :mobile="true"
        :section="section"
        class="card-menu"
      />
      <div class="card-details">
        <div class="card-title">{{ item.learning_path.name }}</div>
        <div class="card-subtitle">{{ item.user.name }}</div>
        <div class="card-text">
          Company: <span class="text-dark">{{ item.user.company.name }}</span>
          <br />
          Enrollment Date:
          <span class="text-dark">{{
            item.enrolled_at | moment("MM/DD/YYYY")
          }}</span>
          <br />
          Status: <span class="text-dark">{{ item.progress }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListCardMixin from "mixins/ListCard";
import EnrollmentMenu from "./EnrollmentMenu";
export default {
  mixins: [ListCardMixin],
  components: { EnrollmentMenu },
  props: {
    section: { type: String, default: "training" },
  },
};
</script>